// ABHA / ABDM permission slugs - single source for labels, groups and role defaults.
// Slugs and defaults mirror the backend (app/middleware/role_permissions.py);
// the backend returns slugs only, so labels live here.
import { STAFF_ROLES } from './staff';

export const ABDM_GROUPS = {
  ABHA: 'ABHA',
  SHARING: 'Linking our records to ABHA',
  OTHER_HOSPITALS: 'ABHA consent & records',
};

// Toggleable permissions, in display order. Plain words an admin understands.
export const ABDM_PERMISSIONS = [
  { slug: 'ABHA_VERIFY', group: ABDM_GROUPS.ABHA, label: "Verify a patient's existing ABHA" },
  { slug: 'ABHA_CREATE', group: ABDM_GROUPS.ABHA, label: 'Create a new ABHA for a patient' },
  { slug: 'ABHA_LINK', group: ABDM_GROUPS.ABHA, label: "Link a verified ABHA to an existing patient" },
  { slug: 'ABHA_SCAN_SHARE', group: ABDM_GROUPS.ABHA, label: 'See Scan & Share patients waiting at the counters and register them' },
  { slug: 'ABHA_CARD_VIEW_STORED', group: ABDM_GROUPS.ABHA, label: "Open a patient's saved ABHA card" },
  { slug: 'HIP_CARE_CONTEXT', group: ABDM_GROUPS.SHARING, label: "Link visit and discharge records to the patient's ABHA" },
  { slug: 'HIP_LINK_SMS', group: ABDM_GROUPS.SHARING, label: 'Send the patient the ABHA app link by SMS' },
  { slug: 'HIU_CONSENT_REQUEST', group: ABDM_GROUPS.OTHER_HOSPITALS, label: 'Ask a patient for consent to see their records from other organisations' },
  { slug: 'HIU_VIEW_RECORDS', group: ABDM_GROUPS.OTHER_HOSPITALS, label: 'See records from other organisations' },
  { slug: 'HIU_VIEW_RAW', group: ABDM_GROUPS.OTHER_HOSPITALS, label: 'See the raw data of a record from another organisation' },
];

export const ABDM_TOGGLEABLE_SLUGS = ABDM_PERMISSIONS.map((p) => p.slug);

// R70: no separate settings permission — the ABDM ID settings stay on the existing admin-only check.
export const ABDM_ALL_SLUGS = [...ABDM_TOGGLEABLE_SLUGS];

// Any-of list: the ABHA tile / page is shown if the user holds any of these.
export const ABDM_ANY_ABHA = ['ABHA_CREATE', 'ABHA_VERIFY', 'ABHA_LINK', 'ABHA_SCAN_SHARE'];

const FRONT_DESK = ['ABHA_VERIFY', 'ABHA_CREATE', 'ABHA_LINK', 'ABHA_SCAN_SHARE', 'HIP_LINK_SMS'];

// Default grants per role (before any admin override). Roles not listed get none.
export const ABDM_ROLE_DEFAULTS = {
  [STAFF_ROLES.ADMIN]: ABDM_ALL_SLUGS,
  // R69 (owner): reception also links records to ABHA and requests / views records from other organisations.
  [STAFF_ROLES.RECEPTIONIST]: [
    ...FRONT_DESK,
    'HIP_CARE_CONTEXT',
    'HIU_CONSENT_REQUEST',
    'HIU_VIEW_RECORDS',
    'HIU_VIEW_RAW',
  ],
  // R131 (owner): doctors do not get Scan & Share (reception attaches scanned patients).
  [STAFF_ROLES.DOCTOR]: [
    ...FRONT_DESK.filter((s) => s !== 'ABHA_SCAN_SHARE'),
    'HIP_CARE_CONTEXT',
    'HIU_CONSENT_REQUEST',
    'HIU_VIEW_RECORDS',
    'HIU_VIEW_RAW',
    'ABHA_CARD_VIEW_STORED',
  ],
};
